const BASE_ACUM_URL = 'https://nocs.acum.org.il/acumsitesearchdb/'

const searchBySongAndPerformer = async (
    songTerm,
    performerTerm = '',
    pageNumber = 1,
    getTranslated = false
) => {
    const resultTypeKey = !getTranslated ? 'musical' : 'translated'
    return new Promise((resolve, reject) => {
        const url =
            BASE_ACUM_URL +
            'searchdb?primarySearchByTypeKey=1&primarySearchByTypeText=' +
            encodeURI(songTerm) +
            '&secondarySearchByTypeKey=2&secondarySearchByTypeText=' +
            encodeURI(performerTerm) +
            '&resultTypeKey=' +
            resultTypeKey +
            '&pageNumber=' +
            pageNumber +
            '&searchMethodTypeKey=partial&resultSortTypeKey=alphabetical'

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                // console.log('acum - search by term:', data)
                if (data.errorCode !== 0) {
                    reject({
                        error: data.errorCode,
                        description: data.errorDescription,
                    })
                    console.log(
                        'From acum.js --- no search results---- rejected'
                    )
                }
                if (data.data && data.data.resultTypeInfos && getTranslated) {
                    const translatedData = data.data.resultTypeInfos.find(
                        (r) => r.resultTypeKey === 'translated'
                    )
                    const originalTranslatedIds = getOriginalAcumIds(
                        translatedData
                    )
                    if (translatedData && translatedData.pageResults) {
                        resolve({
                            total: translatedData.count,
                            data: translatedData.pageResults.map((work, i) =>
                                getWorkDetails(
                                    work,
                                    originalTranslatedIds
                                        ? originalTranslatedIds[i]
                                            ? originalTranslatedIds[i]
                                            : null
                                        : null
                                )
                            ),
                        })
                        return
                    }
                }
                if (data.data && data.data.resultTypeInfos && !getTranslated) {
                    const musicalData = data.data.resultTypeInfos.find(
                        (r) => r.resultTypeKey === 'musical'
                    )
                    if (musicalData && musicalData.pageResults) {
                        resolve({
                            total: musicalData.count,
                            data: musicalData.pageResults.map((work, i) =>
                                getWorkDetails(work)
                            ),
                        })
                        return
                    }
                }
                resolve([])
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const searchByTerm = async (term, pageNumber = 1, getTranslated) => {
    const url = !getTranslated
        ? BASE_ACUM_URL +
          'searchdb?term=' +
          encodeURI(term) +
          '&resultTypeKey=musical&pageNumber=' +
          pageNumber
        : BASE_ACUM_URL +
          'searchdb?term=' +
          encodeURI(term) +
          '&nameType=W&resultTypeKey=translated&pageNumber=' +
          pageNumber +
          '&searchLanguageCode=he-IL'
    return new Promise((resolve, reject) => {
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                if (data.errorCode !== 0) {
                    reject({
                        error: data.errorCode,
                        description: data.errorDescription,
                    })
                    console.log(
                        'From acum.js --- no search results---- rejected'
                    )
                }

                if (data.data && data.data.resultTypeInfos) {
                    const musicalData = data.data.resultTypeInfos.find(
                        (r) => r.resultTypeKey === 'musical'
                    )
                    const translatedData = data.data.resultTypeInfos.find(
                        (r) => r.resultTypeKey === 'translated'
                    )
                    const originalTranslatedIds = getOriginalAcumIds(
                        translatedData
                    )

                    if (
                        musicalData &&
                        musicalData.pageResults &&
                        !getTranslated
                    ) {
                        resolve({
                            total: musicalData.count,
                            data: musicalData.pageResults.map((work, i) =>
                                getWorkDetails(work)
                            ),
                        })
                        return
                    }
                    if (
                        translatedData &&
                        translatedData.pageResults &&
                        getTranslated
                    ) {
                        resolve({
                            total: translatedData.count,
                            data: translatedData.pageResults.map((work, i) =>
                                getWorkDetails(
                                    work,
                                    originalTranslatedIds
                                        ? originalTranslatedIds[i]
                                            ? originalTranslatedIds[i]
                                            : null
                                        : null
                                )
                            ),
                        })
                        return
                    }
                }
                resolve([])
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const searchById = (id, pageNumber = 1, callback) => {
    return new Promise((resolve, reject) => {
        const url =
            BASE_ACUM_URL +
            'getworkinfo?workId=' +
            id +
            '&pageNumber=' +
            pageNumber
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                // console.log(
                //     'acum - search by id:',
                //     data?.data?.workVersionCount
                // )
                callback && callback(data?.data?.workVersionCount)
                if (data.errorCode !== 0) {
                    reject({
                        error: data.errorCode,
                        description: data.errorDescription,
                    })
                }
                if (data.data && data.data.workVersions) {
                    // console.log('acum searchById data', data)
                    const versions = data.data.workVersions.map((work) =>
                        getWorkDetails(work)
                    )
                    resolve({ data: versions, total: versions.length })
                }
                resolve([])
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const getCreatorDetails = (creator) => ({
    heb_name: creator.creatorHebName,
    eng_name: creator.creatorEngName,
    number: creator.creatorIpBaseNumber,
})

const getPerformerDetails = (performer) => ({
    heb_name: performer.performerHebName,
    eng_name: performer.performerEngName,
    number: performer.number,
})

const getCreatorsArray = (work, creatorType) => {
    return work[creatorType]
        ? work[creatorType].map((creator) => getCreatorDetails(creator))
        : []
}

const getOriginalAcumIds = (translatedData) => {
    const originalAcumIDS = []
    if (translatedData && translatedData.pageResults) {
        translatedData.pageResults.map((work) => {
            const originalId = work.original?.translatedVersion_Id
            if (originalId) {
                originalAcumIDS.push(originalId)
            }
        })
        return originalAcumIDS
    } else return null
}

const getWorkDetails = (work, originalTranslatedId) => {
    console.log('from get work details ', work)
    let composers = getCreatorsArray(work, 'composers')
    let lyricists = getCreatorsArray(work, 'authors')

    const arrangers = getCreatorsArray(work, 'arrangers')
    const creators = getCreatorsArray(work, 'creators')
    const translator = getCreatorsArray(work, 'translators')
    let akum_id = work['work_id']
    akum_id = akum_id?.length === 9 ? akum_id.substring(0, 6) : akum_id

    const composersAndAuthors = getCreatorsArray(work, 'composersAndAuthors')

    if (composersAndAuthors?.length > 0) {
        composers = composersAndAuthors
        lyricists = composersAndAuthors
    }
    lyricists = translator?.length > 0 ? translator : lyricists

    const workDetails = {
        full_work_id: work['fullWorkId'],
        id: akum_id,
        work_language: work['workLanguage'],
        work_heb_name: work['workHebName'],
        work_eng_name: work?.original ? work.original['workEngName'] : null,
        registration_date: work['registration_date'],
        publication_date: work['publication_date'],
        //translator: translator,
        composers: composers,
        lyricists: lyricists,
        arrangers: arrangers,
        creators: creators,
        youtube_id: work['youtubeId'],
    }
    if (originalTranslatedId) {
        workDetails.translated_version_id =
            originalTranslatedId.length === 9
                ? originalTranslatedId.substring(0, 6)
                : originalTranslatedId
    }

    if (work.versionNumber) {
        workDetails.version_number = work.versionNumber
    }

    if (work.time) {
        workDetails.time = work.time
    }

    if (work.performer) {
        workDetails.performer = getPerformerDetails(work.performer)
    }

    return workDetails
}

export default {
    searchByTerm,
    searchById,
    searchBySongAndPerformer,
}
